import { KeysOf, ValueOf } from '~types/common';

export type ColorKeys = KeysOf<typeof colors>;

export type Colors = {
  [key in ColorKeys]: ValueOf<typeof colors>;
};

const colors = {
  white100: '#fff',
  gray200: '#fafafa',
  gray300: '#f4f4f4',
  gray400: '#ebebeb',
  gray500: '#e0e0e0',
  gray600: '#ccc',
  gray650: '#A5A5A5',
  gray700: '#7d7d7d',
  gray800: '#444',
  gray900: '#333',
  black100: '#000',
  magenta100: '#FFEDF2',
  magenta200: '#FCE1E8',
  magenta300: '#eeb4c3',
  magenta500: '#E27893',
  magenta600: '#DC567A',
  magenta700: '#D63461',
  magenta800: '#7B264D',
  magenta900: '#641846',
  yellow300: '#F8DDC7',
  yellow400: '#FFC400',
  yellow500: '#ED4B4B',
  mint400: '#84E6E5',
  blue500: '#165EB3',
  bluegray500: '#48586B',
  greypink300: '#FD828C',
  greymint300: '#7AC8C1',
  greypurple300: '#87519B',
  greypurple400: '#713A86',
  red500: '#ED4B4B',
  greynavy100: '#9AA0CF',
  greynavy300: '#525A9D',
} as const;

export default colors;
